import Modal from "../../../common/components/Modal.jsx"
import Textareafield from "../../../common/components/Textareafield.jsx";
import Textfield from "../../../common/components/Textfiled.jsx"
import Select from "../../../common/components/Select.jsx"
import Checkbox from "../../../common/components/Checkbox.jsx";
import Button from "../../../common/components/Button.jsx"

const TYPES = [
  { value: 'work', label: 'Trabajo' },
  { value: 'training', label: 'Capacitación' },
  { value: 'goal', label: 'Meta' }
]

function ModalTaskKanban({ isOpen, onClose, task, onChangeTask, loading, errors, onSaveTask, supportFile, onChangeSupportFile }) {

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className="modal-body text-start p-3">
        <h1 className="h2">Guardar Tarea o actividad</h1>
        <div>
          <Textfield name="title" label="Título" placeholder="Título" value={task.title} error={errors?.title} onChange={onChangeTask} />
          <Textareafield name="description" label="Descripción" placeholder="Descripción" value={task.description} error={errors?.description} onChange={onChangeTask} />
          <Textfield type="date" name="date" label="Fecha" value={task.date} error={errors?.date} onChange={onChangeTask} />
          <Select name="type" label="Tipo" value={task.type} error={errors?.type} onChange={onChangeTask} options={TYPES} />

          <div>
            <Checkbox name="status" label="Pendiente" value="pendiente" checked={task.status === 'pendiente'} onChange={onChangeTask} />
            <Checkbox name="status" label="Completada" value="completada" checked={task.status === 'completada'} onChange={onChangeTask} />
          </div>

          {task.status === 'completada' && (
            <div className="mt-4">
              <label className="form-label fw-bold">Documento de soporte (PDF)</label>
              {task.supportDocument && (
                <p className="text-success small mb-1">
                  📄 Ya tiene documento: <a href={task.supportDocument} target="_blank" rel="noreferrer">Ver documento</a>
                </p>
              )}
              <input
                type="file"
                className="form-control"
                accept=".pdf,.doc,.docx,.xls,.xlsx,.png,.jpg,.jpeg"
                onChange={(e) => onChangeSupportFile(e.target.files[0] || null)}
              />
              {errors?.supportDocument && <small className="text-danger">{errors.supportDocument}</small>}
            </div>
          )}

          {task.type === 'training' && task.status === 'completada' && (
            <div className="mt-4">
              <Textfield name="numberTrainees" label="Número de capacitados" placeholder="Número de capacitados" type="number" value={task.numberTrainees || ""} error={errors?.numberTrainees} onChange={onChangeTask} />
              <Textfield name="peopleOrganization" label="Personas de la organización" placeholder="Personas de la organización" type="number" value={task.peopleOrganization || ""} error={errors?.peopleOrganization} onChange={onChangeTask} />
            </div>
          )}
          <footer className="modal-footer mt-3">
            <Button loading={loading} disabled={loading} onClick={onSaveTask}>Guardar</Button>
          </footer>
        </div>
      </div>
    </Modal>
  )
}
export default ModalTaskKanban;
